module.exports = __webpack_public_path__ + "img/DSC04039.4d6ce2ca.jpg";